<template>
  <div class="app-container">
    <navigation title="联系我们"></navigation>
    <div class="not-login">
      <div class="message-logo">
        <span></span>
      </div>
      <van-tabs @click="mapChange" background="none" v-model="active">
        <van-tab title="国家图书馆总馆"></van-tab>
        <van-tab title="国家图书馆古籍馆"></van-tab>
      </van-tabs>
      <!-- 地图 -->
      <div id="map"/>
      <div class="content" v-if="active===0">
        <div class="title">地址：<span class="address">北京市 海淀区 中关村南大街33号 国家图书馆</span></div>
        <div class="title">邮编：<span class="address">100081</span></div>
        <div class="title">服务咨询电话：
          <span class="tel">
            <a href="tel:4006006988">4006006988</a>、
            <a href="tel:010-88545426">(+86 10) 88545426</a>
          </span>
        </div>
        <div class="title">E-mail：
          <span @click="copy" data-clipboard-text="webmaster@nlc.cn" class="email">webmaster@nlc.cn</span>
        </div>
      </div>
      <div class="content1" v-else>
        <div class="title">地址：<span class="address">北京市西城区文津街7号 国家图书馆古籍馆</span></div>
        <div class="title">邮编：<span class="address">100081</span></div>
        <div class="title">联系电话：
          <span class="tel">
            <a href="tel:010-88003091">(+86 10)88003091</a>
          </span>
        </div>
      </div>
      <version type="position"></version>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox, Toast } from 'vant'
import navigation from '../../components/navigation'
import version from '../../components/version'
import Clipboard from 'clipboard'
import AMapLoader from '@amap/amap-jsapi-loader';

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox).use(Toast)
export default {
  name: 'messageBoard',
  components: {navigation, version},
  data () {
    return {
      active: 0,
      map: null,
      mapKey: 'd7702d8058560689b7b466eee9da64cd',
      list: [],
      loading: false,
      finished: false,
      checked: true,
      choose: true,
      checkAll: false,
      ifManagement: true
    }
  },
  created () {
    window.scroll(0, 0)
  },
  mounted() {
    this.initMap()
  },
  methods: {
    mapChange  (title) {
      console.log('title',title)
      if(title===0) {
        this.toZongGuan()
      } else {
        this.toGuJiGuan()
      }
    },
    toZongGuan() {
      let name = "国家图书馆总馆";
      let position = [116.323321,39.94394]
      this.addMarker(name, position)
    },
    toGuJiGuan() {
      let name = "国家图书馆古籍馆";
      let position = [116.385357,39.922661]
      this.addMarker(name, position)
    },
    addMarker(name, position) {
      this.map.setCenter(position)
      let markerPosition = new AMap.LngLat(position[0],position[1])
      // 创建一个 Marker 实例：
      var marker = new AMap.Marker({
        // 东二门坐标
        position: markerPosition,
        title: name
      });
      var url='https://m.amap.com/navi/?dest='+position.join(",")+'&destName='+name+'&key='+this.mapKey;
      // 信息窗体的内容
      var content = [
        '<div>'+name+'｜<a target="_blank" href="'+url+'">到这去</a></div>'
      ];
      // 创建 infoWindow 实例
      var infoWindow = new AMap.InfoWindow({
        position: markerPosition,
        offset: new AMap.Pixel(0, -30),
        content: content.join("<br>")
      });
      infoWindow.open(this.map);
      // 将创建的点标记添加到已有的地图实例：
      this.map.add(marker);
    },
    initMap() {
      let that = this
      AMapLoader.load({
        "key": that.mapKey,// 申请好的Web端开发者Key，首次调用 load 时必填
        "version": "1.4.15",   // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        "plugins": [
          'AMap.ToolBar',
          'AMap.Scale',
          'AMap.HawkEye',
          'AMap.MapType',
          'AMap.Geolocation'
        ],           // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        "AMapUI": {             // 是否加载 AMapUI，缺省不加载
          "version": '1.1',   // AMapUI 缺省 1.1
          "plugins":[],       // 需要加载的 AMapUI ui插件
        },
        "Loca":{                // 是否加载 Loca， 缺省不加载
          "version": '1.3.2'  // Loca 版本，缺省 1.3.2
        },
      }).then((AMap)=>{
        that.map = new AMap.Map('map',{
          zoom:15
        });
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        that.map.addControl(new AMap.ToolBar());
        // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
        that.map.addControl(new AMap.Scale());
        that.toZongGuan()
      }).catch(e => {
        console.log(e);
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad () {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1)
        }

        // 加载状态结束
        this.loading = false

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true
        }
      }, 1000)
    },
    onManagement () {
      this.checkAll = true
      this.ifManagement = false
    },
    onChoose (item) {
    },
    onCal () {
      this.ifManagement = true
      this.checkAll = false
    },
    copy () {
      var clipboard = new Clipboard(".email"); //单页面引用
      clipboard.on("success", e => {
        // 释放内存
        clipboard.destroy();
        Toast.success('已复制');
      });
      clipboard.on("error", e => {
        // 不支持复制
        Toast.fail('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    }
  }
}
</script>

<style scoped>
.app-container{
  background:url('../../assets/img/not-login.png') no-repeat;
  background-size:100% 100%;
  position:absolute;
  min-height:calc(100% - .92rem);
  overflow-y:scroll;
  top: 0px;
  bottom: 0px;
}
.not-login{
  width:7.5rem;
  min-height:12.58rem;
  text-align: left;
  font-size:.28rem;
  color:#94979C;
  margin-top:.92rem;
  position:relative;
  font-family: SourceHanSerifCN-Regular;
}
.message-logo{
  width:3.93rem;
  height:.77rem;
  padding:.4rem 1.69rem 0 1.88rem;
}
.message-logo span{
  width:100%;
  height:100%;
  display:inline-block;
  background-size:100%
}
.content,.content1{
  width:5.81rem;
  margin:.32rem .64rem 0 .65rem;
  border:2px solid #008095;
  border-radius: 16px;
  border: 2px solid rgba(0, 128, 149, 0.2);
  padding:.2rem .2rem 0 .2rem;
  line-height:.42rem;
  font-size:.24rem;
  font-weight: 500;
  color: #444649;
}
.content{
  height:2.4rem;
}
.content1{
  height:1.8rem;
}
#map{
  width:4.91rem;
  height:4.15rem;
  margin:.32rem .64rem 0 .65rem;
  border:2px solid #008095;
  border: 2px solid rgba(0, 128, 149, 0.2);
  padding:.34rem .65rem 0 .65rem;
  line-height:.42rem;
  font-size:.28rem;
  font-weight: 500;
  color: #444649;
}
.title{
  margin:.1rem 0 0 0;
}
.email,.tel a{
  color:#008095
}
.address{
  color:#008095
}
>>>.van-tab--active .van-tab__text{
  font-size:.36rem !important;
  line-height: .51rem;
  font-family: SourceHanSerifCN-SemiBold;
}
>>>.van-tabs .van-tab__text{
  margin-top:.4rem;
  font-size:.28rem;
  line-height: .51rem;
}
>>>.van-tabs__wrap{
  height:1rem;
}
</style>



// WEBPACK FOOTER //
// src/view/messageBoard/index.vue